import React from 'react';
import { PageCard, PageCardWrapper } from '@ui';
import { SplitPage } from '@ui';
import { PublicPageMessaging } from '@ui/PublicPageMessaging';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { ROUTES } from '@constants/routes';
import { Container } from '@ui';

const FourOhFourWrapper = styled.div`
  ${PageCardWrapper} {
    padding: 40px 24px;
    text-align: center;

    -webkit-box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.1);
  }
`;

const ErrorCode = styled.h1`
  font-size: 120px;
  font-weight: 700;
  margin: 0;
  color: ${({ theme }) => theme.themeColors.primaryCtaButton};
  line-height: 1;
`;

const ErrorTitle = styled.h2`
  font-size: 32px;
  font-weight: 600;
  margin: 16px 0;
  color: ${({ theme }) => theme.themeColors.text};
`;

const ErrorDescription = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.themeColors.secondaryText};
  margin: 0 0 32px 0;
  line-height: 1.5;
`;

const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 300px;
  margin: 0 auto;
`;

const StyledLink = styled(Link)`
  padding: 12px 24px;
  border-radius: 6px;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.2s ease;

  &.primary {
    background-color: ${({ theme }) => theme.themeColors.primaryCtaButton};
    color: ${({ theme }) => theme.themeColors.buttonText};

    &:hover {
      opacity: 0.9;
      transform: translateY(-1px);
    }
  }

  &.secondary {
    background-color: transparent;
    color: ${({ theme }) => theme.themeColors.text};
    border: 1px solid ${({ theme }) => theme.themeColors.border};

    &:hover {
      background-color: ${({ theme }) => theme.themeColors.componentNoOpacity};
      transform: translateY(-1px);
    }
  }
`;

export default function FourOhFourPage() {
  return (
    <SplitPage
      LeftComponent={<PublicPageMessaging />}
      RightComponent={
        <FourOhFourWrapper>
          <PageCard>
            <Container>
              <ErrorCode>404</ErrorCode>
              <ErrorTitle>Page Not Found</ErrorTitle>
              <ErrorDescription>
                The page you are looking for might have been removed, had its name changed, or is temporarily
                unavailable.
              </ErrorDescription>
              <LinksContainer>
                <StyledLink to={ROUTES.home} className="primary">
                  Go to Home
                </StyledLink>
                <StyledLink to={ROUTES.faq} className="secondary">
                  Visit FAQ
                </StyledLink>
                <StyledLink to={ROUTES.login} className="secondary">
                  Sign In
                </StyledLink>
                <StyledLink to={ROUTES.signup} className="secondary">
                  Sign Up
                </StyledLink>
              </LinksContainer>
            </Container>
          </PageCard>
        </FourOhFourWrapper>
      }
    />
  );
}
